import React, {useState} from 'react';
import TreeItem from '@material-ui/lab/TreeItem';
import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import {useTranslation} from 'react-i18next';
import {useApiNotification} from "../ui/ApiNotificationProvider";
import {fetchUserCapabilities} from "../../api/user-capability-functions";
import {useCapability} from "../../auth/CapabilityContext";
import {addOrganizationUnit} from "../../api/organization-unit-functions";

const useStyles = makeStyles({
    root: {
        height: 'auto',
        flexGrow: 1,
        maxWidth: 700,
        display: 'flex'
    },
    form: {
        display: 'flex',
        alignItems: 'center'
    },
    input: {
        flexGrow: 1,
        margin: '5px 20px'
    }
});

const OrganizationUnitTreeAdd = ({
                                     unit,
                                     onUnitAdded,
                                     onProcessingAction,
                                     disableProcessingAction
                                 }: any) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const [error, setError] = useState(false);
    const [name, setName] = useState('');
    const {showSuccess, handleError} = useApiNotification();
    const {setCapabilities} = useCapability();

    const nameChangeHandler = (e: any) => {
        const txt = e.target.value;
        if (error && txt) setError(false);
        setName(txt);
    };

    const addOrgUnit = async (e: any, orgUnitName: any) => {
        e.preventDefault();
        e.stopPropagation();
        if (!orgUnitName)
            return setError(true);
        onProcessingAction(true);
        await addOrganizationUnit(unit.organizationId, unit.id, orgUnitName)
            .then((data) => {
                if (data.items && data.items.length) {
                    setName('');
                    onUnitAdded(data.items[0]);
                    showSuccess();
                }
            })
            .then(() => fetchUserCapabilities(unit.organizationId).then(setCapabilities))
            .catch(handleError)
            .finally(() => onProcessingAction(false));
    };

    return <TreeItem key={unit.id + 'add'} nodeId={unit.id + 'add'} label={
        <form className={classes.form} noValidate autoComplete="off" onSubmit={e => addOrgUnit(e, name)}>
            <FormControl className={classes.input} error={error} size="small" >
                <InputLabel htmlFor="org-unit-name">
                    {
                        error ? `${t('_Common.Labels.Name')} ${t('_Common.Messages.IsRequired')}` :
                            t('_Common.Labels.Name')
                    }
                </InputLabel>
                <Input id="org-unit-name"
                       aria-describedby="org-unit-name"
                    // eslint-disable-line react/jsx-tag-spacing
                    // @ts-ignore
                       variant="outlined"
                       onChange={nameChangeHandler}
                       onClick={e => e.stopPropagation()}
                       value={name}
                       disabled={disableProcessingAction}/>
            </FormControl>

            <Button variant="contained" color="primary" size="small" disabled={disableProcessingAction}
                    onClick={(e) => addOrgUnit(e, name)}>{t('_Common.Labels.Add')}
            </Button>
        </form>
    }/>;
};


export default OrganizationUnitTreeAdd;
